function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHangup = function SvgHangup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.97 12.2c.06.77-.22 1.52-.77 2.06l-2.2 2.2a1.711 1.711 0 0 1-2.18.2l-1.73-1.21A2.675 2.675 0 0 1 15 12.82l.11-1.58c-2.04-.43-4.18-.42-6.24.02L9 12.89c.16.94-.27 1.97-1.11 2.56l-1.72 1.21a1.7 1.7 0 0 1-2.18-.2l-2.2-2.2c-.55-.54-.83-1.29-.78-2.06.06-.77.44-1.48 1.06-1.95 5.84-4.42 14.01-4.42 19.85 0 .62.47 1 1.18 1.05 1.95z",
    style: {
      fill: "#fff"
    }
  }));
};

export default SvgHangup;